import en from './en.json';
import ko from './ko.json';

export const messages = {
  en,
  ko,
};



// WEBPACK FOOTER //
// ./src/locale/messages.tsx